<template>
  <div class="meter-real-time-alarm">
    <div class="alarm-header">
      <div class="header-cell index-cell">{{ $t('序号') }}</div>
      <div class="header-cell meter-id-cell">{{ $t('表编号') }}</div>
      <div class="header-cell meter-type-cell">{{ $t('表类型') }}</div>
      <div class="header-cell fault-type-cell">{{ $t('故障类型') }}</div>
      <div class="header-cell time-cell">{{ $t('告警时间') }}</div>
    </div>
    <div class="alarm-list-container">
      <vue-seamless-scroll 
        :data="list" 
        class="seamless-warp" 
        ref="seamlessScroll" 
        :class-option="classOption" 
        @ScrollEnd="ScrollEnd"
      >
        <div class="alarm-list">
          <div class="alarm-row" v-for="(item, index) in list" :key="index">
            <div class="alarm-cell index-cell">
              <span class="index-badge">{{ index + 1 }}</span>
            </div>
            <div class="alarm-cell meter-id-cell">{{ item.meterId }}</div>
            <div class="alarm-cell meter-type-cell">{{ item.mtName }}</div>
            <div class="alarm-cell fault-type-cell">
              <span class="fault-type" :class="getFaultClass(item.meterWarnType)">{{ $t(meterWarnTypeObj[item.meterWarnType]) }}</span>
            </div>
            <div class="alarm-cell time-cell">{{ formatTime(item.updateTime) }}</div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { meterWarnTypeObj } from '@/utils/constants/commonConstant'

export default {
  name: 'MeterRealTimeAlarmList',
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      list: [],
      url: {
        list: "/jeecg-charge/meter/meterUpDataFaultLastRecord/list"
      },
      pageNo: 1,
      pageSize: 50,
      errorNum: 0,
      meterWarnTypeObj
    }
  },
  computed: {
    goOn() {
      return this.errorNum < 5
    },
    classOption() {
      return {
        step: 0.5,
        limitMoveNum: this.list.length,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ScrollEnd() {
      // 滚动到末尾时重新获取数据
      if (this.goOn) {
        this.getData()
      }
    },
    
    init() {
      this.resetData()
      this.getData()
    },
    
    resetData() {
      this.list = []
    },
    
    getData() {
      getAction(this.url.list, { pageSize: this.pageSize }).then(res => {
        if (res.success) {
          this.list = res.result.records || []
          this.$nextTick(() => {
            if (this.$refs.seamlessScroll) {
              this.$refs.seamlessScroll.reset()
            }
          })
        }
      }).catch(() => {
        this.list = this.getMockData()
      })
    },
    
    getMockData() {
      return [
        {
          meterId: 'WM001234',
          mtName: '智能水表',
          meterWarnType: '1',
          updateTime: '2024-01-15 10:30:15'
        },
        {
          meterId: 'WM005678',
          mtName: '远传水表',
          meterWarnType: '2',
          updateTime: '2024-01-15 10:25:32'
        },
        {
          meterId: 'WM009012',
          mtName: '智能水表',
          meterWarnType: '3',
          updateTime: '2024-01-15 10:20:45'
        },
        {
          meterId: 'WM003456',
          mtName: '远传水表',
          meterWarnType: '1',
          updateTime: '2024-01-15 10:15:28'
        },
        {
          meterId: 'WM007890',
          mtName: '智能水表',
          meterWarnType: '2',
          updateTime: '2024-01-15 10:10:33'
        }
      ]
    },
    
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
    },
    
    getFaultClass(type) {
      const classMap = {
        '1': 'fault-normal',
        '2': 'fault-warning',
        '3': 'fault-critical'
      }
      return classMap[type] || 'fault-normal'
    }
  }
}
</script>

<style lang="less" scoped>
.meter-real-time-alarm {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
}

.alarm-header {
  display: flex;
  align-items: center;
  background: rgba(0, 168, 255, 0.15);
  color: #fff;
  height: 35px;
  margin-bottom: 5px;
  border-radius: 4px;
}

.header-cell {
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  color: #00a8ff;
}

.index-cell {
  width: 12%;
}

.meter-id-cell {
  width: 25%;
}

.meter-type-cell {
  width: 20%;
}

.fault-type-cell {
  width: 20%;
}

.time-cell {
  width: 23%;
}

.alarm-list-container {
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.alarm-list {
  padding: 0;
}

.alarm-row {
  display: flex;
  align-items: center;
  padding: 8px 5px;
  margin-bottom: 3px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.alarm-row:hover {
  background: rgba(0, 168, 255, 0.1);
  transform: translateX(2px);
}

.alarm-row:nth-child(even) {
  background: rgba(255, 255, 255, 0.08);
}

.alarm-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  color: #fff;
  font-size: 12px;
}

.index-cell {
  width: 12%;
}

.meter-id-cell {
  width: 25%;
  font-family: monospace;
}

.meter-type-cell {
  width: 20%;
}

.fault-type-cell {
  width: 20%;
}

.time-cell {
  width: 23%;
  color: rgba(255, 255, 255, 0.7);
}

.index-badge {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: rgba(0, 168, 255, 0.3);
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 11px;
  font-weight: bold;
}

.fault-type {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
}

.fault-normal {
  background: rgba(0, 200, 83, 0.2);
  color: #00c853;
}

.fault-warning {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.fault-critical {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.seamless-warp {
  height: 100%;
}

.seamless-warp::-webkit-scrollbar {
  width: 4px;
}

.seamless-warp::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.seamless-warp::-webkit-scrollbar-thumb {
  background: rgba(0, 168, 255, 0.3);
  border-radius: 2px;
}
</style>